// Mock data for all dashboard components
export const mockData = {
    analytics: {
      revenueData: [
        { month: 'Jan', revenue: 4500, bookings: 45 },
        { month: 'Feb', revenue: 5200, bookings: 52 },
        { month: 'Mar', revenue: 6800, bookings: 68 },
        { month: 'Apr', revenue: 7900, bookings: 79 },
        { month: 'May', revenue: 8100, bookings: 81 },
        { month: 'Jun', revenue: 9500, bookings: 95 },
      ],
      activityData: [
        { name: 'Whale Watching', value: 35 },
        { name: 'Dolphin Swimming', value: 28 },
        { name: 'Turtle Release', value: 42 },
        { name: 'Wildlife Safari', value: 25 },
      ],
      summaryData: {
        totalRevenue: 42000,
        totalBookings: 370,
        totalActivities: 12,
        averageRating: 4.7,
      }
    },
    calendar: {
      bookings: [
        { date: '2024-03-15', activity: 'Whale Watching', slots: 3 },
        { date: '2024-03-16', activity: 'Dolphin Swimming', slots: 5 },
        { date: '2024-03-17', activity: 'Turtle Release', slots: 2 },
        { date: '2024-03-18', activity: 'Wildlife Safari', slots: 4 },
      ]
    },
    customers: [
      {
        id: '1',
        name: 'John Doe',
        email: 'john@example.com',
        bookings: 3,
        joined: '2024-01-15',
        totalSpent: 450,
        lastBooking: '2024-03-10'
      },
      {
        id: '2',
        name: 'Jane Smith',
        email: 'jane@example.com',
        bookings: 5,
        joined: '2024-02-01',
        totalSpent: 750,
        lastBooking: '2024-03-12'
      },
      // Add more mock customers...
    ],
    settings: {
      businessName: 'Wildlife Adventures Co.',
      contactEmail: 'contact@wildlifeadventures.com',
      phoneNumber: '+1 (555) 123-4567',
      address: '123 Nature Street, Wildlife City, WC 12345',
      businessHours: '9:00 AM - 6:00 PM',
      timezone: 'UTC-5',
      currency: 'USD'
    }
  };